/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $TotoPlayerSmall = {
    properties: {
        id: {
            type: 'number',
            isRequired: true,
        },
        user: {
            type: 'UserEssential',
            isRequired: true,
        },
        name: {
            type: 'string',
            isRequired: true,
        },
        left: {
            type: 'boolean',
            isRequired: true,
        },
        kicked: {
            type: 'boolean',
            isRequired: true,
        },
        creator: {
            type: 'boolean',
            isRequired: true,
        },
    },
} as const;
